import moment from 'moment';
import fields from "./fields.utils.js";

const schema_landlord = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,
        placeholder: 'Cover Date'
    },
    "cover_level": {
        label: 'Cover Level',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    'property_postcode': {
        label: "Property Postcode",
        placeholder: "E.g. 'CR0 3RL'",
        value: '',
        type: "text",
        required: true,
    },
    "property_total": {
        label: 'Number of Properties',
        type: 'select',
        value: '1',
        options: [],
        required: true,
    },
    "property_use": {
        label: 'Property Use',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    "property_value": {
        label: 'Property Value (estimated overall value for all the properties)',
        type: 'select',
        value: '',
        options: [],
        required: true,
    },
    'property_type_flat': {
        label: 'Flat',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_block_of_flats': {
        label: 'Block of Flats',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_room_only': {
        label: 'Room Only',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_house': {
        label: 'House',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_shop': {
        label: 'Shop',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_cafe': {
        label: 'Café',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_restaurant': {
        label: 'Restaurant',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_industrial': {
        label: 'Industrial',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_warehouse': {
        label: 'Warehouse',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_office': {
        label: 'Office',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_hotel': {
        label: 'Hotel',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_airbnb': {
        label: 'Airbnb',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    'property_type_other': {
        label: 'Other',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true,
    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,
    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',

    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_landlord;
